

import React from 'react';
import Image from 'next/image';

type ProductImageProps = {
  src: string;
  alt: string;
};

const ProductImage = ({ src, alt }: ProductImageProps) => {
  return (
    <div style={{ width: 400, height: 400, position: 'relative', overflow: 'hidden' }}>
      <Image
        src={src}
        alt={alt}
        fill
        style={{ objectFit: 'cover' }}
        sizes="(max-width: 400px) 100vw, 400px"
        priority
      />
    </div>
  );
};

export default ProductImage;
